import { Col, Row } from "reactstrap";
import React, { useState, useEffect } from 'react';
import { SlFormEntryRow, TextInput, SlPageTitle, SlSectionLabel } from "../editors";
import validator from "validator";
import { IdentificationType } from "./IdentificationType";
import { metadataService } from "../../_services";

export const MakePaymentVerifyIdentity = (props) => {
    const [formValue, setFormValue] = useState({
        SocialSecurityNumber: '',
        DOB: '',
        IndividualTaxIdentificationNumber: '',
        identityType: '',
        useSSN: '',
        ssnItinError: true
    });

    useEffect(() => {
        if (!formValue.ssnItinError) {
            props.onChange({
                dob: formValue.DOB,
                ssn: formValue.SocialSecurityNumber,
            });
        } else {
            props.onChange({
                dob: "",
                ssn: "",
            });
        }
    }, [formValue]);

    const handleInput = ({ target: { name, value } }) => {
        let result = { ...formValue, [name]: value }
        if (name === "SocialSecurityItin") {
            if (value.SocialSecurityNumber) {
                result.SocialSecurityNumber = value.SocialSecurityNumber;
            }
            else if (value.IndividualTaxIdentificationNumber) {
                result.IndividualTaxIdentificationNumber = value.IndividualTaxIdentificationNumber;
            }

            result.ssnItinError = !value.isValid;
        }

        setFormValue(result)
    }

    const isFormError = () => {
        return formValue.ssnItinError || validator.isEmpty(formValue.DOB);
    }

    const isIdentificationTypeValid = (fieldName, isValid) => {
        return { formError: !isValid, ssnItinError: !isValid }
    }

    return (
        <div>
            <SlPageTitle pageName="MakePayment" />
            <Row>
                <Col xs={12} md={{ size: 8, offset: 2 }}>
                    <SlSectionLabel centered={true} sectionName="ToMakeAPayment" />
                </Col>
            </Row>
            <IdentificationType
                name={"SocialSecurityItin"}
                isRequired={true}
                showLabel={true}
                onChange={handleInput}
                isValid={isIdentificationTypeValid}
                requireReEntry={true}
            />
            <SlFormEntryRow>
                <TextInput
                    name="DOB"
                    type="date"
                    label={metadataService.getFieldNameLabel("DOB")}
                    onChange={handleInput}
                    value={formValue.DOB}
                    maskOnBlur={true}
                />
            </SlFormEntryRow>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/subcomponents/MakePaymentVerifyIdentity.js